import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { LearningResult } from "../../recommendation.types";
import { requestLearnFromOrders } from "./learnFromOrders.request";

const useLearnFromOrders = (
  options?: MutationOptions<LearningResult, ApiServiceError<ApiError>, void>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestLearnFromOrders,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "affinity"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useLearnFromOrders;
